module.exports = __webpack_public_path__ + "img/CZ25672720.4e1c1b3b.png";